import type { ThunkExtras, GetState, ThunkAction, APIError, Dispatch } from '../../types/app.types';
type GetWalletSuccess = {
  type: 'wallet/GET_WALLET_SUCCESS';
  availableBalance: string;
};
type GetWalletError = {
  type: 'wallet/GET_WALLET_ERROR';
} & APIError;
export type WalletAction = GetWalletSuccess | GetWalletError;
export type WalletState = {
  availableBalance: string | null | undefined;
  error: string | null | undefined;
};
const initialState: WalletState = {
  availableBalance: null,
  error: null,
};
export function getWallet(): ThunkAction<Promise<any>> {
  return function (dispatch: Dispatch, getState: GetState, extras: ThunkExtras): Promise<any> {
    return extras.blinkAPIClient
      .get('/wallet')
      .then((res) => res.data)
      .then((res) => res.availableBalance)
      .then((availableBalance: string) =>
        dispatch({
          type: 'wallet/GET_WALLET_SUCCESS',
          availableBalance,
        })
      )
      .catch((err: APIError) =>
        dispatch({
          type: 'wallet/GET_WALLET_ERROR',
          ...err,
        })
      );
  };
}
export default function walletReducer(state: WalletState = { ...initialState }, action: WalletAction): WalletState {
  switch (action.type) {
    case 'wallet/GET_WALLET_SUCCESS': {
      return { ...state, availableBalance: action.availableBalance, error: null };
    }

    case 'wallet/GET_WALLET_ERROR': {
      return { ...initialState, availableBalance: null, error: 'Error loading wallet' };
    }

    default:
      return state;
  }
}
